module.exports = {"description":"The Grandmaster is an unplayable Universal Champion"}


//////////////////
// WEBPACK FOOTER
// ./src/data/guides/grandmaster.json
// module id = 451
// module chunks = 0